/*
 Created by qing on 2020/12/29
 Des: 我的待办
 */
import BaseConfig from "../BaseConfig";
import {CONFIG_TYPE__TODO, TODO_SHOW_TYPE__WIDE} from "../type";
import context from '../../main.js'

class TodoConfig extends BaseConfig {
  constructor() {
    super()

    this.h = 5
    this.w = 60

    this.minW = 60
    this.maxW = 60
    this.minH = 5
    this.maxH = 5


    this.pH = 4
    this.pW = 60

    this.pMinW = 60
    this.pMaxW = 60
    this.pMinH = 4
    this.pMaxH = 4

    this.toEdit = false
    this.todoBadge = 0
    this.ccBadge = 0
    this.remindBadge = 0
    this.timeoutBadge = 0

    this.showType = TODO_SHOW_TYPE__WIDE
  }

  get title() {
    return this.configName || TodoConfig._title
  }

  set title(content) {
    this.configName = content
  }

}

TodoConfig._title = '我的待办'
TodoConfig.type = CONFIG_TYPE__TODO

TodoConfig.prototype.configType = TodoConfig.type
TodoConfig.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    showType: this.showType
  }
}
TodoConfig.prototype.setConf = function (opts) {
  this.setBase(opts)
  this.showType = opts.showType

  if (opts.hasOwnProperty('pH')) this.pH = opts.pH
  if (opts.hasOwnProperty('pW')) this.pW = opts.pW
  if (opts.hasOwnProperty('pX')) this.pX = opts.pX
  if (opts.hasOwnProperty('pY')) this.pY = opts.pY
  if (opts.showType === TODO_SHOW_TYPE__WIDE) {
    this.minW = 60
    this.maxW = 60
    this.minH = 5
    this.maxH = 5
  } else {
    this.minW = 10
    this.maxW = 20
    this.minH = 8
    this.maxH = 15
  }
}
TodoConfig.prototype.getValue = function () {
  context.$store.dispatch('actionWorkspaceNewTabList')
    .then(res => {
      res.forEach(item => {
        if (item.id === '4') {
          this.todoBadge = item.count > 999 ? '999+' : item.count
        } else if (item.id === '1') {
          // 催办
          this.remindBadge = item.count > 999 ? '999+' : item.count
        } else if (item.id === '2') {
          // 即将超时
          this.timeoutBadge = item.count > 999 ? '999+' : item.count
        } else if (item.id === '6') {
          this.ccBadge = item.count > 999 ? '999+' : item.count
        }
      })
      console.log('value--', this.todoBadge)
  }).catch(console.error)

}

export default TodoConfig
